import { useSelector } from "react-redux";
import { RootState } from "store";

export const useUserCurrentLocation = () => {
  const userCurrentLocationData = useSelector((state: RootState) => state["USER"].currentLocation);
  return userCurrentLocationData.data;
};

export const useUserCurrentLocationLoading = () => {
  const userCurrentLocationData = useSelector((state: RootState) => state["USER"].currentLocation);
  return userCurrentLocationData.loadingStatus;
};
